export const clickableWrapperDiameter = 'fit-content';
